import {
  UPDATE_MISSING_TRANSCRIPT_APPEARANCE,
  UPDATE_EVENT_LEVEL_APPEARANCE,
  UPDATE_SEGMENTS_REMOVED,
} from "../actions/localActions";

const LocalReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_MISSING_TRANSCRIPT_APPEARANCE: {
      return {
        ...state,
        missingTranscriptAppearances: [].concat(
          state.missingTranscriptAppearances || [],
          [action.display_id]
        ),
      };
    }
    case UPDATE_EVENT_LEVEL_APPEARANCE: {
      return {
        ...state,
        eventLevelPopupAppearances: [].concat(
          state.eventLevelPopupAppearances || [],
          [action.display_id]
        ),
      };
    }
    case UPDATE_SEGMENTS_REMOVED: {
      return { ...state, segmentsRemoved: action.display_id };
    }
    default:
      return state;
  }
};

export default LocalReducer;
